import { Container, Grid, CircularProgress, useTheme } from '@mui/material';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import { useState, useEffect } from 'react';
import { PortalScreenHeader } from '../../../../components/PortalScreenHeader';
import { RestaurantSubmissionsTable } from './components';
import RestaurantSubmissionService from '../../../../services/RestaurantSubmissionService';
import { RestaurantSubmission } from '../../../../models/DB';

const RestaurantSubmissions = () => {
    const theme = useTheme();
    const [isLoading, setIsLoading] = useState(false);
    const [submissions, setSubmissions] = useState<RestaurantSubmission[]>([]);

    const fetchSubmissions = async () => {
        setIsLoading(true);
        const data = await RestaurantSubmissionService.getAll();
        setSubmissions(data);
        setIsLoading(false);
    };

    useEffect(() => {
        fetchSubmissions();
    }, []);

    const handleRefresh = () => {
        fetchSubmissions();
    };

    return (
        <Container
            component='main'
            maxWidth='xl'
            sx={{
                height: '100%',
                paddingX: { xs: 0, md: 2 },
            }}
        >
            {isLoading ? (
                <Grid container justifyContent='center' mt={20}>
                    <Grid item>
                        <CircularProgress
                            size={40}
                            sx={{ color: theme.palette.primary.main }}
                        />
                    </Grid>
                </Grid>
            ) : (
                <>
                    <PortalScreenHeader
                        title='Restaurant Clients'
                        subtitle='View and manage restaurant client applications'
                        icon={<RestaurantIcon />}
                    />
                    <RestaurantSubmissionsTable
                        submissions={submissions}
                        onRefresh={handleRefresh}
                    />
                </>
            )}
        </Container>
    );
};

export default RestaurantSubmissions;
